exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/modules/_wks-ext.js
// module id = 287
// module chunks = 0